import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { StorageService } from 'src/app/core/services/storage.service';
import { StorageEnum } from '../../enums/storage.enum';
import { WearerDetailsPage } from 'src/app/features/wearer-management/pages/wearer-details/wearer-details.page';
import { UiUtilityService } from 'src/app/core/services/ui-utility.service';
import { ALERT_STATUS, MODAL_PAGE_TYPE, MSG_PARTS, PATIENT_SYNC } from '../../config/app.constant';
import { DashboardService } from 'src/app/features/dashboard/services/dashboard.service';
import { HeaderService } from 'src/app/core/services/header.service';
import { CasparService } from 'src/app/features/dashboard/services/caspar.service';
import { CasparFrameComponent } from '../caspar-frame/caspar-frame.component';
import { Subscription } from 'rxjs';
import { RoomDetailsPage } from 'src/app/features/settings/room-management/room-details/room-details.page';

@Component({
  standalone: true,
  selector: 'app-message-drawer',
  templateUrl: './message-drawer.component.html',
  styleUrls: ['./message-drawer.component.scss'],
  imports: [IonicModule, CommonModule, FormsModule],
})


export class MessageDrawerComponent implements OnInit, OnDestroy {
  messages: any = [];
  loading = false;
  lastUpdatedPCC = '';
  isLastUpdateLoading = false;
  private subscriptions: Subscription[] = [];

  constructor(private modalCtrl: ModalController, private storageService: StorageService, private uiUtilityService: UiUtilityService, private dashboardService: DashboardService, private headerService: HeaderService, private casparService: CasparService) {

  }


  // ✅ This must be inside the class
  stripBraces(part: string): string {
    return part.replace(/[{}]/g, '');
  }
  ngOnInit() {
    this.subscriptions.push(
      this.headerService.updateMessagesList.subscribe((msgs: []) => {
        this.messages = msgs;
      })
    );
    if (this.messages.length) {
      // this.checkSyncTypeStatusPCC(PATIENT_SYNC);
    }
  }

  // checkSyncTypeStatusPCC(syncType: string) {
  //   this.isLastUpdateLoading = true;
  //   const selectedFacility = this.headerService.getCurrentFacility;
  //   this.dashboardService.syncPCCStatus(selectedFacility.facilityId, syncType).subscribe({
  //     next: (res: any) => {
  //       this.isLastUpdateLoading = false;
  //       if (res.data && res.data[0]?.resolved) {
  //         this.lastUpdated = this.dashboardService.getCurrentTimeInTimezone();
  //       } else {
  //         this.lastUpdated = this.messages[0].timestamp;
  //       }
  //     }, error: () => {
  //       this.isLastUpdateLoading = false;
  //       this.lastUpdated = this.messages[0].timestamp;
  //     }
  //   });
  // }

  clearAll() {
    const temp = { lastNotificationId: this.messages[0].id, cleared: this.messages[0].id };
    this.storageService.setLocalStorage(
      StorageEnum.notifications,
      temp,
      true
    );
    return this.modalCtrl.dismiss('', 'cleared');
  }

  onLinkClick(part: string, data: any) {
    if (!(part === MSG_PARTS.RESIDENT_ID || part === MSG_PARTS.ROOM_NAME)) {
      return;
    }
    this.close();
    if (part === MSG_PARTS.RESIDENT_ID) {
      const menuItem = { component: WearerDetailsPage, id: 'wearer-list', confirm: false, pageType: MODAL_PAGE_TYPE, modalData: { wearerId: data.wearerId, isRootPage: true } };
      this.uiUtilityService.menuClicked.next(menuItem);
    } else if (part === MSG_PARTS.ROOM_NAME) {
      const menuItem = { component: RoomDetailsPage, id: 'room-list', confirm: false, pageType: MODAL_PAGE_TYPE, modalData: { roomId: data.roomId, isRootPage: true } };
      this.uiUtilityService.menuClicked.next(menuItem);
    }
  }


  close() {
    this.modalCtrl.dismiss();
  }

  async launchCaspar(message: any) {
    // alok
    const params: any = {};
    if (message?.casparBedId) {
      params.bedId = message?.casparBedId;
    }
    if (message?.casparPatientId) {
      params.patientId = message?.casparPatientId;
    }
    if (message?.alertId) {
      params.alertId = message?.alertId;
    }
    if (message?.alertid) {
      params.alertId = message?.alertid;
    }
    const iframeSrc = this.casparService.getCasparIFrameParams(params);
    const modal = await this.modalCtrl.create({
      component: CasparFrameComponent,
      componentProps: {
        iframeSrc
      },
    });
    return await modal.present();
  }

  onSilenceClicked(message: any) {
    message.processing = true;
    if (message?.fallAlertStatus === ALERT_STATUS.RESOLVE) {
      this.casparService.setFallAlertResolveStatus(message.alertId).subscribe({
        next: (res: any) => {
          message.processing = false;
          if (res.success) {
            this.headerService.onGetMessagesData.next(true);
            message['fallAlertStatus'] = '';
            message['actionableAlert'] = false;
            this.launchCaspar(message);
          }
        }, error: () => {
          message.processing = false;
        }
      });
      return;
    }
    this.casparService.setFallAlertStatus(message.roomId, message.alertId).subscribe({
      next: (res: any) => {
        message.processing = false;
        if (res.success) {
          this.headerService.onGetMessagesData.next(true);
          message['fallAlertStatus'] = '';
          this.dashboardService.onCheckAndBlowAlarm.next(message.roomId);
        }
      }, error: () => {
        message.processing = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
